export enum EUserTransferQueryKey {
  TRANSFER_USER_ASSET = 'transfer-user-asset',
  LIST_USER_ASSET_TRANSFERS = 'list-user-asset-transfers',
  CHECK_BUYOUT_ELIGIBILITY = 'check-buyout-eligibility',
}
